export default {"src":"/_next/static/media/arrowLeftRight-highlight.04af6d6a.svg","height":23,"width":23};